<template>
  <bm-dialog :label="$m.welcome_to_brewman" @accept="accept" @cancel="cancel">
    <v-container pa-0>
      <v-row>
        <v-col :cols="12">
          <div v-html="$m.welcome_intro" />
        </v-col>
        <v-col :cols="12" align="center">
          <v-img
            :src="selectDatabasePng"
            max-width="300"
            alt="Select Database"
          />
        </v-col>
        <v-col :cols="12">
          <div>{{ $m.welcome_switch_database }}</div>
        </v-col>
        <v-col :cols="12">
          <div v-html="$m.welcome_need_help"></div>
        </v-col>
      </v-row>
    </v-container>

    <template #controls="props">
      <bm-dialog-controls v-bind="props" :cancelable="true">
        <template #controls-confirm-text>
          {{ $m.welcome_get_started }}
        </template>
      </bm-dialog-controls>
    </template>
  </bm-dialog>
</template>

<script setup lang="ts">
import BmDialog from "@/components/dialogs/BmDialog.vue";
import BmDialogControls from "@/components/dialogs/BmDialogControls.vue";
import {
  useReactiveDialogScriptSetup,
  type DialogEvents,
} from "@/components/mixins/dialogs";

import selectDatabasePng from "@/assets/images/app/welcome/select_database.png";

export interface BmWelcomeDialogEvents extends DialogEvents {}

const emit = defineEmits<BmWelcomeDialogEvents>();

const { accept, cancel } = useReactiveDialogScriptSetup(emit);
</script>
